module.exports = __webpack_public_path__ + "img/bg-livro.513fed95.png";